"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from 'react';
import { Trophy } from 'lucide-react';
import { cn } from '@/lib/utils';

// Constants
const GlbPlayerTeam = {
  HOME: {
    name: "HOME",
    value: 1
  },
  VISITOR: {
    name: "VISITOR",
    value: 2
  },
  UNDEFINED: {
    name: "UNDEFINED",
    value: 0
  }
};
interface LiveScoreboardProps {
  gameState: any; // GameStateSnapshotv2.state
  playersData: any; // gamePlayersData
  settingsData: any; // gameSettingsData
  sport: string;
}
export function LiveScoreboard(t0) {
  const $ = _c(94);
  const {
    gameState,
    playersData,
    settingsData,
    sport
  } = t0;
  if (!gameState) {
    return null;
  }
  gameState.currentSet || 1;
  const matchFinished = gameState.matchFinished || false;
  const teamServing = gameState.teamServing || 0;
  const homeSets = gameState.scoreSet?.[GlbPlayerTeam.HOME.name] || 0;
  const visitorSets = gameState.scoreSet?.[GlbPlayerTeam.VISITOR.name] || 0;
  const homePointsRaw = gameState.scorePoint?.[GlbPlayerTeam.HOME.name] || 0;
  const visitorPointsRaw = gameState.scorePoint?.[GlbPlayerTeam.VISITOR.name] || 0;
  const isTieBreak = gameState.inTieBreak || gameState.inSuperTieBreak;
  let homePointStr;
  let visitorPointStr;
  if (isTieBreak) {
    const t1 = gameState.scoreTieBreak?.[GlbPlayerTeam.HOME.name] || 0;
    let t2;
    if ($[0] !== t1) {
      t2 = t1.toString();
      $[0] = t1;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    homePointStr = t2;
    const t3 = gameState.scoreTieBreak?.[GlbPlayerTeam.VISITOR.name] || 0;
    let t4;
    if ($[2] !== t3) {
      t4 = t3.toString();
      $[2] = t3;
      $[3] = t4;
    } else {
      t4 = $[3];
    }
    visitorPointStr = t4;
  } else {
    const fmt = _temp;
    let t1;
    if ($[4] !== homePointsRaw || $[5] !== visitorPointsRaw) {
      t1 = fmt(homePointsRaw, visitorPointsRaw);
      $[4] = homePointsRaw;
      $[5] = visitorPointsRaw;
      $[6] = t1;
    } else {
      t1 = $[6];
    }
    const hStr = t1;
    let t2;
    if ($[7] !== homePointsRaw || $[8] !== visitorPointsRaw) {
      t2 = fmt(visitorPointsRaw, homePointsRaw);
      $[7] = homePointsRaw;
      $[8] = visitorPointsRaw;
      $[9] = t2;
    } else {
      t2 = $[9];
    }
    const vStr = t2;
    if (hStr === "Ad") {
      homePointStr = "Ad";
      visitorPointStr = "";
    } else {
      if (vStr === "Ad") {
        homePointStr = "";
        visitorPointStr = "Ad";
      } else {
        homePointStr = hStr;
        visitorPointStr = vStr;
      }
    }
  }
  const setsCount = typeof settingsData?.setCount === "number" ? settingsData.setCount : typeof settingsData?.setCount === "string" ? parseInt(settingsData.setCount) : 1;
  let data;
  if ($[10] !== gameState.scoreGame || $[11] !== matchFinished || $[12] !== setsCount) {
    data = [];
    for (let i = 1; i <= setsCount; i++) {
      const setKey = `set${i}`;
      const scores = gameState.scoreGame?.[setKey];
      const h = scores?.[GlbPlayerTeam.HOME.name] || 0;
      const v = scores?.[GlbPlayerTeam.VISITOR.name] || 0;
      if (matchFinished && h === 0 && v === 0) {
        continue;
      }
      data.push({
        setNum: i,
        h,
        v
      });
    }
    $[10] = gameState.scoreGame;
    $[11] = matchFinished;
    $[12] = setsCount;
    $[13] = data;
  } else {
    data = $[13];
  }
  const setsData = data;
  const homeWon = matchFinished && homeSets > visitorSets;
  const visitorWon = matchFinished && visitorSets > homeSets;
  const isHomeServing = teamServing === GlbPlayerTeam.HOME.value;
  const isVisitorServing = teamServing === GlbPlayerTeam.VISITOR.value;
  const oneVsOne = settingsData?.oneVsOne === true || settingsData?.oneVsOne === "true";
  let t1;
  if ($[14] !== playersData) {
    t1 = spot => {
      if (!playersData) {
        return null;
      }
      return Object.values(playersData).find(p_0 => {
        const s = typeof p_0.fldPlayerCourtSpot === "string" ? parseInt(p_0.fldPlayerCourtSpot) : p_0.fldPlayerCourtSpot;
        return s === spot;
      }) as any;
    };
    $[14] = playersData;
    $[15] = t1;
  } else {
    t1 = $[15];
  }
  const getPlayerData = t1;
  let t2;
  if ($[16] !== getPlayerData || $[17] !== oneVsOne) {
    t2 = t3 => {
      const {
        spot: spot_0,
        align: t4,
        colorClass
      } = t3;
      const align = t4 === undefined ? "left" : t4;
      if (oneVsOne && (spot_0 === 2 || spot_0 === 4)) {
        return <div className="flex-1" />;
      }
      const player = getPlayerData(spot_0);
      const name = player?.fldPlayerDisplayName && player.fldPlayerDisplayName !== "MVPlayer" && player.fldPlayerDisplayName !== "Empty slot..." ? player.fldPlayerDisplayName : "MVPlayer";
      return <div className={cn("flex-1 flex items-center gap-2", align === "right" ? "justify-end" : "justify-start")}><span className={cn("text-xl sm:text-2xl font-bold font-sriracha drop-shadow-md truncate max-w-[150px] sm:max-w-[200px]", colorClass)}>{name}</span></div>;
    };
    $[16] = getPlayerData;
    $[17] = oneVsOne;
    $[18] = t2;
  } else {
    t2 = $[18];
  }
  const PlayerLabel = t2;
  let t3;
  if ($[19] !== sport) {
    t3 = () => <img src={`/drawables/icon_${sport ? sport.toLowerCase() : "padel"}.png`} alt="Serve" className="w-5 h-5 sm:w-6 sm:h-6 object-contain" onError={_temp2} />;
    $[19] = sport;
    $[20] = t3;
  } else {
    t3 = $[20];
  }
  const ServeIcon = t3;
  let t4;
  bb0: {
    if (!gameState.timeStamp) {
      t4 = "";
      break bb0;
    }
    let t5;
    if ($[21] !== gameState.timeStamp) {
      t5 = new Date(gameState.timeStamp).toLocaleTimeString();
      $[21] = gameState.timeStamp;
      $[22] = t5;
    } else {
      t5 = $[22];
    }
    t4 = t5;
  }
  const timeString = t4;
  let t5;
  if ($[23] !== PlayerLabel) {
    t5 = <div className="flex-1 flex justify-start min-w-0"><PlayerLabel spot={1} align="left" colorClass="text-[#529AFF]" /></div>;
    $[23] = PlayerLabel;
    $[24] = t5;
  } else {
    t5 = $[24];
  }
  let t6;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <img src="/drawables/mvplayer_logo.png" alt="MVP Logo" className="h-8 sm:h-12 w-auto object-contain mx-2 drop-shadow-lg" />;
    $[25] = t6;
  } else {
    t6 = $[25];
  }
  let t7;
  if ($[26] !== PlayerLabel) {
    t7 = <div className="flex-1 flex justify-end min-w-0"><PlayerLabel spot={2} align="right" colorClass="text-[#529AFF]" /></div>;
    $[26] = PlayerLabel;
    $[27] = t7;
  } else {
    t7 = $[27];
  }
  let t8;
  if ($[28] !== t5 || $[29] !== t7) {
    t8 = <div className="flex items-end px-2 sm:px-6 pb-2 min-h-[40px]">{t5}{t6}{t7}</div>;
    $[28] = t5;
    $[29] = t7;
    $[30] = t8;
  } else {
    t8 = $[30];
  }
  let t9;
  if ($[31] !== homeSets) {
    t9 = <div className="w-16 h-full bg-[#529AFF] rounded-lg flex items-center justify-center shrink-0"><span className="text-black text-4xl font-bold font-lato">{homeSets}</span></div>;
    $[31] = homeSets;
    $[32] = t9;
  } else {
    t9 = $[32];
  }
  let t10;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="w-4" />;
    $[33] = t10;
  } else {
    t10 = $[33];
  }
  let t11;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <span className="text-white text-3xl sm:text-4xl font-bold truncate font-sans tracking-tight mr-3">HOME</span>;
    $[34] = t11;
  } else {
    t11 = $[34];
  }
  let t12;
  if ($[35] !== homeWon) {
    t12 = homeWon && <Trophy className="w-6 h-6 sm:w-8 sm:h-8 text-[#FFD700] shrink-0 animate-bounce" />;
    $[35] = homeWon;
    $[36] = t12;
  } else {
    t12 = $[36];
  }
  let t13;
  if ($[37] !== ServeIcon || $[38] !== isHomeServing || $[39] !== matchFinished) {
    t13 = !matchFinished && isHomeServing && <ServeIcon />;
    $[37] = ServeIcon;
    $[38] = isHomeServing;
    $[39] = matchFinished;
    $[40] = t13;
  } else {
    t13 = $[40];
  }
  let t14;
  if ($[41] !== t12 || $[42] !== t13) {
    t14 = <div className="flex-1 flex flex-col justify-center min-w-0 mr-3"><div className="flex items-center">{t11}{t12}{t13}</div></div>;
    $[41] = t12;
    $[42] = t13;
    $[43] = t14;
  } else {
    t14 = $[43];
  }
  let t15;
  if ($[44] !== matchFinished || $[45] !== setsData) {
    t15 = <div className="flex items-center h-full mr-2">{setsData.map((set, idx) => <div key={idx} className="w-[50px] sm:w-[70px] h-full flex items-center justify-center"><span className={cn("text-white text-3xl sm:text-4xl font-lato", matchFinished && set.h > set.v ? "font-bold text-[#529AFF]" : "font-normal opacity-80")}>{set.h}</span></div>)}</div>;
    $[44] = matchFinished;
    $[45] = setsData;
    $[46] = t15;
  } else {
    t15 = $[46];
  }
  let t16;
  if ($[47] !== homePointStr || $[48] !== matchFinished) {
    t16 = !matchFinished && <div className="w-[80px] sm:w-[100px] h-full bg-[#404040] rounded-lg flex items-center justify-center shrink-0 ml-1 border border-white/10"><span className="text-white text-4xl sm:text-5xl font-bold font-lato tracking-tighter">{homePointStr}</span></div>;
    $[47] = homePointStr;
    $[48] = matchFinished;
    $[49] = t16;
  } else {
    t16 = $[49];
  }
  let t17;
  if ($[50] !== t14 || $[51] !== t15 || $[52] !== t16 || $[53] !== t9) {
    t17 = <div className="flex items-center h-[100px] bg-[#2A2A2A]/90 rounded-xl p-3 w-full overflow-hidden shadow-xl border border-white/5 relative z-10">{t9}{t10}{t14}{t15}{t16}</div>;
    $[50] = t14;
    $[51] = t15;
    $[52] = t16;
    $[53] = t9;
    $[54] = t17;
  } else {
    t17 = $[54];
  }
  let t18;
  if ($[55] !== visitorSets) {
    t18 = <div className="w-16 h-full bg-[#ef4444] rounded-lg flex items-center justify-center shrink-0"><span className="text-black text-4xl font-bold font-lato">{visitorSets}</span></div>;
    $[55] = visitorSets;
    $[56] = t18;
  } else {
    t18 = $[56];
  }
  let t19;
  if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <div className="w-4" />;
    $[57] = t19;
  } else {
    t19 = $[57];
  }
  let t20;
  if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <span className="text-white text-3xl sm:text-4xl font-bold truncate font-sans tracking-tight mr-3">VISITOR</span>;
    $[58] = t20;
  } else {
    t20 = $[58];
  }
  let t21;
  if ($[59] !== visitorWon) {
    t21 = visitorWon && <Trophy className="w-6 h-6 sm:w-8 sm:h-8 text-[#FFD700] shrink-0 animate-bounce" />;
    $[59] = visitorWon;
    $[60] = t21;
  } else {
    t21 = $[60];
  }
  let t22;
  if ($[61] !== ServeIcon || $[62] !== isVisitorServing || $[63] !== matchFinished) {
    t22 = !matchFinished && isVisitorServing && <ServeIcon />;
    $[61] = ServeIcon;
    $[62] = isVisitorServing;
    $[63] = matchFinished;
    $[64] = t22;
  } else {
    t22 = $[64];
  }
  let t23;
  if ($[65] !== t21 || $[66] !== t22) {
    t23 = <div className="flex-1 flex flex-col justify-center min-w-0 mr-3"><div className="flex items-center">{t20}{t21}{t22}</div></div>;
    $[65] = t21;
    $[66] = t22;
    $[67] = t23;
  } else {
    t23 = $[67];
  }
  let t24;
  if ($[68] !== matchFinished || $[69] !== setsData) {
    t24 = <div className="flex items-center h-full mr-2">{setsData.map((set_0, idx_0) => <div key={idx_0} className="w-[50px] sm:w-[70px] h-full flex items-center justify-center"><span className={cn("text-white text-3xl sm:text-4xl font-lato", matchFinished && set_0.v > set_0.h ? "font-bold text-[#ef4444]" : "font-normal opacity-80")}>{set_0.v}</span></div>)}</div>;
    $[68] = matchFinished;
    $[69] = setsData;
    $[70] = t24;
  } else {
    t24 = $[70];
  }
  let t25;
  if ($[71] !== matchFinished || $[72] !== visitorPointStr) {
    t25 = !matchFinished && <div className="w-[80px] sm:w-[100px] h-full bg-[#404040] rounded-lg flex items-center justify-center shrink-0 ml-1 border border-white/10"><span className="text-white text-4xl sm:text-5xl font-bold font-lato tracking-tighter">{visitorPointStr}</span></div>;
    $[71] = matchFinished;
    $[72] = visitorPointStr;
    $[73] = t25;
  } else {
    t25 = $[73];
  }
  let t26;
  if ($[74] !== t18 || $[75] !== t23 || $[76] !== t24 || $[77] !== t25) {
    t26 = <div className="flex items-center h-[100px] bg-[#2A2A2A]/90 rounded-xl p-3 w-full overflow-hidden shadow-xl border border-white/5 mt-2 relative z-10">{t18}{t19}{t23}{t24}{t25}</div>;
    $[74] = t18;
    $[75] = t23;
    $[76] = t24;
    $[77] = t25;
    $[78] = t26;
  } else {
    t26 = $[78];
  }
  let t27;
  if ($[79] !== PlayerLabel) {
    t27 = <div className="flex-1 flex justify-start min-w-0"><PlayerLabel spot={4} align="left" colorClass="text-[#ef4444]" /></div>;
    $[79] = PlayerLabel;
    $[80] = t27;
  } else {
    t27 = $[80];
  }
  let t28;
  if ($[81] !== timeString) {
    t28 = timeString && <div className="text-[#8E9285] text-xs font-lato pt-1 opacity-70 mx-2">{timeString}</div>;
    $[81] = timeString;
    $[82] = t28;
  } else {
    t28 = $[82];
  }
  let t29;
  if ($[83] !== PlayerLabel) {
    t29 = <div className="flex-1 flex justify-end min-w-0"><PlayerLabel spot={3} align="right" colorClass="text-[#ef4444]" /></div>;
    $[83] = PlayerLabel;
    $[84] = t29;
  } else {
    t29 = $[84];
  }
  let t30;
  if ($[85] !== t27 || $[86] !== t28 || $[87] !== t29) {
    t30 = <div className="flex items-start px-2 sm:px-6 pt-2 min-h-[40px]">{t27}{t28}{t29}</div>;
    $[85] = t27;
    $[86] = t28;
    $[87] = t29;
    $[88] = t30;
  } else {
    t30 = $[88];
  }
  let t31;
  if ($[89] !== t17 || $[90] !== t26 || $[91] !== t30 || $[92] !== t8) {
    t31 = <div className="flex flex-col gap-1 p-4 select-none w-full max-w-4xl mx-auto">{t8}{t17}{t26}{t30}</div>;
    $[89] = t17;
    $[90] = t26;
    $[91] = t30;
    $[92] = t8;
    $[93] = t31;
  } else {
    t31 = $[93];
  }
  return t31;
}
function _temp2(e) {
  e.currentTarget.style.display = "none";
}
function _temp(p, opp) {
  if (p === 0) {
    return "0";
  }
  if (p === 15) {
    return "15";
  }
  if (p === 30) {
    return "30";
  }
  if (p === 40) {
    return "40";
  }
  if (p === 50) {
    return opp === 40 ? "Ad" : "40";
  }
  return p.toString();
}